module.exports = __webpack_public_path__ + "static/media/og.a9665cbe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/og.jpg?v2
// module id = 148
// module chunks = 0